import React from 'react';
import { 
  faHeart, 
  faBrain, 
  faInfinity, 
  faUsers, 
  faLeaf, 
  faChartLine 
} from '@fortawesome/free-solid-svg-icons';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProgramBenefitCard from '../components/ProgramBenefitCard';

const ProgramPage = () => {
  const programBenefits = [
    {
      icon: faHeart,
      title: "Kesehatan Fisik",
      description: "Meningkatkan stamina, fleksibilitas, dan kesehatan jantung melalui gerakan senam yang terstruktur",
      iconBgColor: "bg-blue-100",
      iconColor: "text-blue-600",
      benefits: [
        "Meningkatkan sirkulasi darah",
        "Memperkuat otot dan tulang",
        "Meningkatkan keseimbangan tubuh"
      ]
    },
    {
      icon: faBrain,
      title: "Kesehatan Mental",
      description: "Mengurangi stress dan meningkatkan ketenangan pikiran melalui meditasi dan pernafasan",
      iconBgColor: "bg-yellow-100",
      iconColor: "text-yellow-600",
      benefits: [
        "Mengurangi kecemasan",
        "Meningkatkan fokus",
        "Memperbaiki kualitas tidur"
      ]
    },
    {
      icon: faInfinity,
      title: "Spiritual",
      description: "Mengembangkan koneksi spiritual dan meningkatkan kesadaran diri",
      iconBgColor: "bg-purple-100",
      iconColor: "text-purple-600",
      benefits: [
        "Meningkatkan intuisi",
        "Memperdalam meditasi",
        "Koneksi dengan energi kosmik"
      ]
    },
    {
      icon: faUsers,
      title: "Sosial",
      description: "Membangun komunitas yang positif dan saling mendukung",
      iconBgColor: "bg-red-100",
      iconColor: "text-red-600",
      benefits: [
        "Bertemu teman baru",
        "Saling berbagi pengalaman",
        "Dukungan komunitas"
      ]
    },
    {
      icon: faLeaf,
      title: "Keseimbangan Hidup",
      description: "Mencapai harmoni antara kehidupan personal, profesional, dan spiritual",
      iconBgColor: "bg-green-100",
      iconColor: "text-green-600",
      benefits: [
        "Work-life balance",
        "Manajemen emosi",
        "Hidup yang bermakna"
      ]
    },
    {
      icon: faChartLine,
      title: "Pengembangan Diri",
      description: "Meningkatkan potensi diri dan kemampuan personal",
      iconBgColor: "bg-orange-100",
      iconColor: "text-orange-600",
      benefits: [
        "Meningkatkan kepercayaan diri",
        "Mengembangkan kreativitas",
        "Mencapai tujuan hidup"
      ]
    }
  ];

  return (
    <div className="font-sans">
      <Header activePage="program" />
      
      {/* Hero Section */}
      <section className="pt-24 pb-12 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Manfaat Program RTD-CL
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              Rasakan transformasi positif dalam berbagai aspek kehidupan Anda
            </p>
          </div>
        </div>
      </section>

      {/* Program Benefits Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {programBenefits.map((program, index) => (
              <ProgramBenefitCard
                key={index}
                icon={program.icon}
                title={program.title}
                description={program.description}
                benefits={program.benefits}
                iconBgColor={program.iconBgColor}
                iconColor={program.iconColor}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-16 bg-gradient-to-r from-indigo-600 to-purple-600">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Siap Memulai Transformasi Hidup Anda?
          </h2>
          <p className="text-xl text-indigo-100 mb-8 max-w-2xl mx-auto">
            Bergabunglah dengan ribuan peserta yang telah merasakan manfaat luar biasa dari program RTD-CL
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/kontak" 
              className="bg-white text-indigo-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300"
            >
              Hubungi Kami
            </a>
            <a 
              href="/cabang" 
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-indigo-600 transition-colors duration-300"
            >
              Cari Cabang Terdekat
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProgramPage;
